/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
if( $("#only-desktop-product").length > 0 ){
  if ($(window).width() > 767) { 
    $(document).ready(function(){
      lightGallery(document.getElementById("only-desktop-product"),{
        selector:".lightgallery-slide ",
        showZoomInOutIcons:!0,
        actualSize:!1,
        plugins:[lgZoom]
      });
    });
  }
}

$(document).ready(function(){
  var $wrapper = $('#ways-to-wear');
  var $videos = $wrapper.find('.vimeo-video');
  function ways_to_wear_videoSlider(){
    $videos.each(function() {
      var $video = $(this);
      var video_img = $video.closest('.media').data('poster');
      var video_src = $(this).data('src');
      // console.log('$video',$video);
      // console.log('video_img',video_img);
      // console.log('video_src',video_src);
      if( $video.closest('.new-product-kichana-item.slick-current').length > 0 ){
        var play_src = video_src+'&playsinline=1&autoplay=1&mute=1&loop=1&controls=0';
        $video.attr('src',play_src);
      }
    });  
  }
  ways_to_wear_videoSlider();

  // On before slide change
  $wrapper.on('beforeChange', function(event, slick, currentSlide, nextSlide){
    // console.log('event', event);
    // console.log('slick', slick);
    // console.log('currentSlide', currentSlide);
    // console.log('nextSlide', nextSlide);
    var $this_slide = $(this);
    // console.log('$this_slide', $this_slide);
    ways_to_wear_videoSlider();
    var videoDataSrc = $('.new-product-kichana-item[data-slick-index="'+currentSlide+'"]').find('.vimeo-video').data('src');
    $('.new-product-kichana-item[data-slick-index="'+currentSlide+'"]').find('.vimeo-video').attr('src',videoDataSrc);
    var nextDataSrc = $('.new-product-kichana-item[data-slick-index="'+nextSlide+'"]').find('.vimeo-video').data('src');
    $('.new-product-kichana-item[data-slick-index="'+nextSlide+'"]').find('.vimeo-video').attr('src',nextDataSrc+'&playsinline=1&autoplay=1&mute=1&loop=1&controls=0');
  });


  //scroll on swatch click
  $('.template-product form .ProductForm__Variants .ProductForm__Option .ColorSwatchList li').each(function(){
    $(this).on('click', function(){
      var val = $(this).find('input').val();
      
        setTimeout(function() {
        var image_id = $('select[name="id"] option:selected').data('img-id');        
          var width = $(window).width();
          if(width > 998){
            $('.swiper-container .swiper-wrapper .swiper-slide').removeClass('active');
            $('.swiper-container .swiper-wrapper .swiper-slide[data-alt-img="'+image_id+'"]').addClass('active');
          }else{
            var index = $('.swiper-container .swiper-wrapper .swiper-slide[data-alt-img="'+image_id+'"]').data('index');
            console.log(index);
            $('.swiper-pagination span').eq(index - 1).trigger('click');
          }
        }, 150);

       setTimeout(function() {
       $('.Product--large .swiper-slide').each(function(){
             if($(this).hasClass('active')){
               $('html, body').animate({
              scrollTop: $(this).offset().top - 150
              }, 500);
             }
           });
       }, 250);
    });
  });

  //on load
    setTimeout(function() {
    var image_id = $('select[name="id"] option:selected').data('img-id');        
      var width = $(window).width();
      if(width > 998){
        $('.swiper-container .swiper-wrapper .swiper-slide').removeClass('active');
        $('.swiper-container .swiper-wrapper .swiper-slide[data-alt-img="'+image_id+'"]').addClass('active');
      }else{
            var index = $('.swiper-container .swiper-wrapper .swiper-slide[data-alt-img="'+image_id+'"]').data('index');
            console.log(index);
            $('.swiper-pagination span').eq(index - 1).trigger('click');
          }
    }, 150);
    setTimeout(function() {
    $('.Product--large .swiper-slide').each(function(){
         if($(this).hasClass('active')){
           $('html, body').animate({
          scrollTop: $(this).offset().top - 150
          }, 500);
         }
       });
    }, 250);


  $('.Product--large .swiper-slide.youtube-video').find('.ytLink').on('click', function(e){
    console.log('yes clicked');
     $('.Product--large .swiper-slide.youtube-video iframe').addClass('yes')
     $('.Product--large .swiper-slide.youtube-video iframe').attr('src',$(this).attr('href') + '?autoplay=1&mute=1&controls=0');
    // $('.swiper-slide.youtube-video iframe')[0].src = $(this).attr('href') + '?autoplay=1';
    playPauseVideo($('.Product--large .swiper-slide.youtube-video iframe'),"play");
         e.preventDefault();
  });

  function playPauseVideo(slick, control){
  var currentSlide, slideType, startTime, player, video;
  
  // currentSlide = slick.find(".slick-current");
  // slideType = currentSlide.find('iframe').data('type');
  player = slick.get(0);
  //startTime = currentSlide.data("video-start");
  
  switch (control) {
    case "play":
    postMessageToPlayer(player, {
      "event": "command",
      "func": "mute"
    });
    postMessageToPlayer(player, {
      "event": "command",
      "func": "playVideo"
    });
    break;
    case "pause":
    postMessageToPlayer(player, {
      "event": "command",
      "func": "pauseVideo"
    });
    break;
  }
  
  }
  
  function postMessageToPlayer(player, command){
  console.log(command);
  if (player == null || command == null) return;
  player.contentWindow.postMessage(JSON.stringify(command), "*");
  }
});
  
